import { render, staticRenderFns } from "./monthOrder.vue?vue&type=template&id=70825499&scoped=true&"
import script from "./monthOrder.vue?vue&type=script&lang=js&"
export * from "./monthOrder.vue?vue&type=script&lang=js&"
import style0 from "./monthOrder.vue?vue&type=style&index=0&id=70825499&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70825499",
  null
  
)

export default component.exports